import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { ProfileComponent } from 'src/app/pages/profile/profile.component';
import { AuthService } from 'src/app/services/auth-service/auth.service';
import { MessageService } from 'src/app/services/message/message.service';

@Component({
  selector: 'app-homes',
  templateUrl: './homes.component.html',
  styleUrls: ['./homes.component.scss']
})
export class HomesComponent implements OnInit {

  loading = true;
  wlc: any;
  name = "";
  showProfilePopup = false;
  profile: string;
  commonRef: string;

  constructor(private authService: AuthService, private messageService: MessageService, public  dialog: MatDialog, private route: ActivatedRoute) { }

  ngOnInit() {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.name = currentUser.givenName;
    if (!currentUser.familyName || currentUser.familyName.trim() === '') {
      this.showProfilePopup = true;
    }
    this.route.paramMap.subscribe(params => {
      this.wlc = params.get('wlc');
    });
    this.authService.endLoading.subscribe((term) =>{ 
      if(term === "1"){
        this.loading = false
      }
    });
    if(this.messageService.getListProject().length > 0) {
      this.loading = false;
    }
  }


  goToProfile() {
    this.showProfilePopup = false;
      this.dialog.closeAll();
      const dialogConfig = new MatDialogConfig();
      dialogConfig.panelClass = 'contactpanel';
      dialogConfig.id = 'balchal718';
      dialogConfig.width = '550px';
      dialogConfig.autoFocus = false;
      dialogConfig.data = { name: this.name, profile: this.profile, commonRef: this.commonRef };
      //const dialogRef = this.dialog.open(ProfileComponent, dialogConfig);
      const dialogRef = this.dialog.open(ProfileComponent, {
        data: { name: this.name, profile: this.profile, commonRef: this.commonRef },
        panelClass: 'transferclass',
        backdropClass: 'custom-backdrop'
      });
      
  
      dialogRef.afterClosed().subscribe((result: any) => {
      });
  
  }

  closePopup() {
    this.showProfilePopup = false;
  }

}
